export default __webpack_public_path__ + "static/media/truck_outline_blue.b15910e3.svg";